import {
  Ticket,
  FileText,
  Globe,
  Mail,
  AlertTriangle,
  ArrowRightLeft,
  Megaphone,
  Wrench,
  Sparkles,
  MessageSquare,
  CreditCard,
  UserPlus,
} from "lucide-react";

export const notificationTypeIcons: Record<string, typeof Ticket> = {
  ticket_created: Ticket,
  ticket_closed: Ticket,
  ticket_status_changed: ArrowRightLeft,
  document_created: FileText,
  scrape_completed: Globe,
  scrape_failed: AlertTriangle,
  modmail_received: Mail,
  admin_announcement: Megaphone,
  admin_maintenance: Wrench,
  admin_feature_update: Sparkles,
  admin_custom: MessageSquare,
  subscription_changed: CreditCard,
  team_invite: UserPlus,
};
